import {fork} from 'redux-saga/effects';
import settingsSaga from './settings.sagas';
import influencerSaga from './influencer.sagas';
import dashboardSaga from './dashboard.sagas';
import eulaSaga from './eula.sagas';
import userSaga from './user.sagas';
import overviewSaga from './overview.sagas';
import pageSaga from './page.sagas';
import payoutSaga from './payout.sagas';
import taxSaga from './tax.sagas';
import alertsSaga from './alerts.sagas';
import trackingSaga from './tracking.sagas';
import newsSaga from './news.sagas';
import activeUsersSaga from './fortnite-game/activeUsers.sagas';
import activeUsersOverviewSaga from './fortnite-game/activeUsersOverview.sagas';
import gamesSaga from './fortnite-game/games.sagas';
import noGamesSaga from './fortnite-game/noGames.sagas';
import averagePlayTimeSaga from './fortnite-game/averagePlayTime.sagas';
import returnPlayersSaga from './fortnite-game/returnPlayers.sagas';
import trackFGErrorsSaga from './fortnite-game/trackFGErrors.sagas';
import oauthSaga from './oauth.sagas';
import configSaga from './config.sagas';
import myOverallHighlightsSaga from './fortnite-game/myOverallHighlights.sagas';
import myTopPerformingGamesSaga from './fortnite-game/myTopPerformingGames.sagas';
import myTop10GamesSaga from './fortnite-game/myTop10Games.sagas';
import lifetimePlaysSaga from './fortnite-game/lifetimePlays.sagas';
import performanceSaga from './fortnite-game/performance.sagas';
import talonSaga from './talon.sagas';
import rewardsSaga from './fortnite-game/rewards.sagas';
import rewardsTop10GamesSaga from './fortnite-game/rewardsTop10Games.sagas';
import gameXpSaga from './fortnite-game/gameXp.sagas';
import gameXpHighlightsSaga from './fortnite-game/gameXpHighlights.sagas';
import playrateSaga from './fortnite-game/playrate.sagas';

export default function*() {
    yield fork(settingsSaga);
    yield fork(influencerSaga);
    yield fork(dashboardSaga);
    yield fork(eulaSaga);
    yield fork(userSaga);
    yield fork(overviewSaga);
    yield fork(pageSaga);
    yield fork(payoutSaga);
    yield fork(taxSaga);
    yield fork(alertsSaga);
    yield fork(trackingSaga);
    yield fork(newsSaga);
    yield fork(activeUsersSaga);
    yield fork(activeUsersOverviewSaga);
    yield fork(gamesSaga);
    yield fork(noGamesSaga);
    yield fork(averagePlayTimeSaga);
    yield fork(returnPlayersSaga);
    yield fork(oauthSaga);
    yield fork(configSaga);
    yield fork(myOverallHighlightsSaga);
    yield fork(myTopPerformingGamesSaga);
    yield fork(myTop10GamesSaga);
    yield fork(lifetimePlaysSaga);
    yield fork(trackFGErrorsSaga);
    yield fork(performanceSaga);
    yield fork(talonSaga);
    yield fork(rewardsSaga);
    yield fork(rewardsTop10GamesSaga);
    yield fork(gameXpSaga);
    yield fork(gameXpHighlightsSaga);
    yield fork(playrateSaga);
}
